export var checkType = function (el, type) {
    return (Object.prototype.toString.call(el) ===
        "[object ".concat(type[0].toUpperCase() + type.slice(1), "]"));
};
